import dayjs from 'dayjs';
import { TimeSlot } from 'react-schedule-meeting';

export function defaultDateFormat(date: Date): string {
	return dayjs(date).format('DD.MM.YYYY hh:mm');
}

export function getFormattedClockDate(date: Date | undefined): string {
	if (!(date instanceof Date) || isNaN(date.getTime())) {
		return 'Invalid Date';
	}

	return dayjs(date).format('DD.MM.YYYY HH:mm[Uhr]');
}

/**
 * @param {TimeSlot[]} availableTimeSlots
 * @param {TimeSlot[]} unavailableTimeSlots
 * @returns {TimeSlot[]} Available TimeSlots less the intersecting unavailable TimeSlots
 */
export function timeSlotDifference(availableTimeSlots: TimeSlot[], unavailableTimeSlots: TimeSlot[]) {
	if (!availableTimeSlots || !unavailableTimeSlots) return [];

	const orderedAvailableTimeSlots = [...availableTimeSlots].map((slot) => ({
		...slot,
		startTime: new Date(slot.startTime),
		endTime: new Date(slot.endTime),
	}));

	const orderedUnavailableTimeSlots = [...unavailableTimeSlots].map((slot) => ({
		...slot,
		startTime: new Date(slot.startTime),
		endTime: new Date(slot.endTime),
	}));

	const result = [];

	for (let availableSlot of orderedAvailableTimeSlots) {
		let adjustedSlots = [availableSlot];

		for (const unavailableSlot of orderedUnavailableTimeSlots) {
			const unavailableStartTime = unavailableSlot.startTime;
			const unavailableEndTime = unavailableSlot.endTime;

			const newSlots = [];

			for (const slot of adjustedSlots) {
				const slotStartTime = slot.startTime;
				const slotEndTime = slot.endTime;

				if (
					unavailableStartTime >= slotEndTime || // Unavailable slot is completely after
					unavailableEndTime <= slotStartTime // Unavailable slot is completely before
				) {
					newSlots.push(slot); // No overlap, keep the slot as is
				} else {
					// Adjust the available slot based on the overlap
					if (slotStartTime < unavailableStartTime) {
						newSlots.push({
							...slot,
							endTime: unavailableStartTime,
						});
					}
					if (slotEndTime > unavailableEndTime) {
						newSlots.push({
							...slot,
							startTime: unavailableEndTime,
						});
					}
				}
			}

			adjustedSlots = newSlots;
		}

		result.push(...adjustedSlots);
	}

	return result;
}
